// Completed dashboard responses only; never persisted to disk/localStorage.
export function createOverviewCache({ now = Date.now, ttl = 60000, limit = 24 } = {}) {
  const entries = new Map();
  const listeners = new Set();
  let generation = 0;
  return {
    generation: () => generation,
    get(key) {
      const entry = entries.get(key);
      if (!entry) return undefined;
      if (now() - entry.savedAt >= ttl) {
        entries.delete(key);
        return undefined;
      }
      entries.delete(key);
      entries.set(key, entry);
      return entry.value;
    },
    put(key, value, expectedGeneration) {
      if (generation !== expectedGeneration) return false;
      entries.delete(key);
      entries.set(key, { value, savedAt: now() });
      while (entries.size > limit) entries.delete(entries.keys().next().value);
      return true;
    },
    invalidate() {
      entries.clear();
      generation += 1;
      listeners.forEach((listener) => listener());
    },
    subscribe(listener) {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
  };
}

export const overviewCache = createOverviewCache();

// Other tabs on this origin invalidate their own in-memory results as well.
const channel = typeof BroadcastChannel !== "undefined"
  ? new BroadcastChannel("imc-overview-invalidation-v1") : null;
if (channel) channel.onmessage = () => overviewCache.invalidate();
export function invalidateOverviewCache() {
  overviewCache.invalidate();
  channel?.postMessage("invalidate");
}
if (typeof window !== "undefined") {
  window.addEventListener("storage", (event) => {
    if (event.key === "imc_token" || event.key === null) overviewCache.invalidate();
  });
}
